import React, { Fragment } from 'react'
import { Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import Clock from 'components/icons/Clock'
import LocationMark from 'components/icons/LocationMark'
import TeamIcon from 'components/icons/TeamIcon'
import Flex from 'components/Flex'
import {
  BorderDiv,
  BottomData,
  CompanyName,
  InfoSection,
  LocationsDiv,
  RedDot,
  RoleName,
  Vacancies,
} from './Style/style'

import Avatar from 'components/Avatar'

const RoleDetails = ({ data }) => {
  let currentDate = new Date().toJSON()

  return (
    <Flex centerVertically>
      <Avatar
        background
        src={''}
        size={36}
        IconName={data?.corporate?.name?.split('')?.[0]}
        font={18}
      />
      <InfoSection>
        <CompanyName>{data?.corporate?.name}</CompanyName>
        <RoleName>
          <Space>
            {data?.tittle} {data?.postedDate < currentDate ? null : <RedDot />}
          </Space>{' '}
        </RoleName>
        <Flex spaceBetween centerVertically>
          <Space>
            <Clock />
            <BottomData>{data?.jobType?.replace('_', ' ')}</BottomData>
          </Space>
          <BorderDiv>
            <Space>
              <TeamIcon />
              <Vacancies>
                {(() => {
                  const min = typeof data?.minVacancies === 'object' ? data?.minVacancies?.value || data?.minVacancies : data?.minVacancies;
                  const max = typeof data?.maxVacancies === 'object' ? data?.maxVacancies?.value || data?.maxVacancies : data?.maxVacancies;
                  if (min != null && max != null) return `${min} - ${max}`;
                  if (min != null) return String(min);
                  if (max != null) return String(max);
                  return 'Not specified';
                })()}
              </Vacancies>
            </Space>
          </BorderDiv>
          <Space>
            <LocationMark />
            <LocationsDiv>
              {data?.cities?.length === 0 ? (
                'AnyWhere'
              ) : (
                <>
                  {data?.cities?.length &&
                    data?.cities?.map((val, index) => (
                      <Fragment key={index + 'cities'}>
                        {val?.name ? val?.name : val?.state_name}{' '}
                        {data?.cities?.length - 1 != index && ','} &nbsp;
                      </Fragment>
                    ))}
                </>
              )}
            </LocationsDiv>
          </Space>
        </Flex>
      </InfoSection>
    </Flex>
  )
}

export default RoleDetails
